import { SUBSCRIBE_FORM_MESSAGES, SubscribeFormMessages } from "./subscribe-form.messages";
import { SUBSCRIBE_PRODUCT_MESSAGES, SubscribeProductMessages } from "./subscribe-product.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type SubscribeMessages = ActionButtonMessages &
  SidebarMessages &
  SubscribeFormMessages &
  SubscribeProductMessages & {
    // Titles and Labels
    title: string;
    breadCrumbTitle: string;
    personalDataSectionTitle: string;
    paymentDataSectionTitle: string;

    //Error messages
    salesProductNotFoundError: string;
    salesProductNotFoundDescription: string;
    salesProductNotFoundAlt: string;
    salesProductErrorToLoad: string;
  };

export const SUBSCRIBE_MESSAGES: SubscribeMessages = {
  // Titles and Labels
  title: "Assinatura",
  breadCrumbTitle: "Assinatura",
  personalDataSectionTitle: "Os Seus Dados",
  paymentDataSectionTitle: "Informações de Pagamento",

  //Error messages
  salesProductNotFoundError: "Produto não encontrado.",
  salesProductNotFoundDescription: "Não conseguimos encontrar o produto que você está procurando",
  salesProductNotFoundAlt: "Produto não encontrado.",
  salesProductErrorToLoad: "Erro ao carregar o produto de venda. Tente novamente mais tarde.",

  ...SUBSCRIBE_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...SUBSCRIBE_PRODUCT_MESSAGES,
};
